<template>
  <div class="header">
    <div class="logo">
      <img class="img-logo" src="@/assets/main/logo.png" alt="logo" />
    </div>
    <div class="links">
      <ul class="links-bar">
        <li class="default-link">
          <a href="https://wspomnieniazwesela.pl/"
            ><p class="default-text-main-page text">
              {{ $t('navbar.link.home') }}
            </p>
          </a>
        </li>
        <li class="default-link">
          <a href="https://wspomnieniazwesela.pl/blog"
            ><p class="default-text-main-page text">Blog</p>
          </a>
        </li>
        <li class="default-link">
          <a href="https://wspomnieniazwesela.pl/policies/company"
            ><p class="default-text-main-page text">O nas</p>
          </a>
        </li>
        <li class="default-link">
          <a href="https://wspomnieniazwesela.pl/contact"
            ><p class="default-text-main-page text">Kontakt</p>
          </a>
        </li>
      </ul>
      <ul class="links-bar">
        <li class="default-link">
          <a href="https://app.wspomnieniazwesela.pl/"
            ><p class="default-text-main-page text">Kod wydarzenia</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$bar-width: 500px;

.header {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 10px 0 15px;
  margin: auto;
}

.links {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px 15px;

  @media (max-width: $bar-width) {
    flex-wrap: wrap;
  }
}

.links-bar {
  margin: auto;
  flex: 1 0 20%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.logo {
  flex: 1 0 auto;
  display: flex;
  justify-content: center;
}

.img-logo {
  width: 170px;
  padding: 10px 0;
}

.highlight {
  .text {
    font-weight: 700;
    font-size: 1.5em;
  }
}
</style>
